<template>
  <div>
    <app-history
      @clicked="
        showDialog = true;
        currentPlace = initPlace;
      "
      title="افزودن غذا خوری"
    />

    <div>
      <v-data-table
        :items="places"
        :headers="placesHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.active`]="{ item }">
          {{ item.active ? "بله" : "خیر" }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="dialogButton" rounded @click="editItem(item)"
            >ویرایش</v-btn
          >
          <v-btn class="dialogButton" rounded @click="removeItem(item)"
            >حذف</v-btn
          >
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> نام</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field v-model="currentPlace.name"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> آدرس </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-textarea
            outlined
            v-model="currentPlace.address"
            no-resize
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="10"> فعال </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentPlace.active"></v-switch>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="
            showDialog = false;
            isEdit = false;
          "
        >
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import {
  GetBranchDeliveryPlace,
  SavePlace,
  DeletePlace,
} from "@/api/deliveryplace";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      places: [],
      currentPlace: {},
      initPlace: {
        name: "",
        address: "",
        active: true,
        id: "0",
      },

      isEdit: false,

      placesHeaders: [
        {
          text: "شناسه",
          value: "id",
          width: "10%",
        },
        {
          text: "نام",
          value: "name",
          width: "20%",
          sortable: false,
        },

        {
          text: "آدرس",
          value: "address",
          width: "40%",
        },

        {
          text: "فعال",
          value: "active",
          width: "5",
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.currentPlace = this.initPlace;
    if (this.currentBranch) this.GetBranchDeliveryPlace();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },

  methods: {
    
    GetBranchDeliveryPlace() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetBranchDeliveryPlace(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.places = response.data.items;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    editItem(item) {
      this.currentPlace = Object.assign({}, item);
      this.showDialog = true;
      this.isEdit = true;
    },
    removeItem(item) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", item.id);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این مکان هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    applyRequest() {
      var text = "";

      if (this.currentPlace.name == "") {
        text = "فرد بایستی انتخاب شود.";
      } else if (this.currentPlace.address == "") {
        text = "آدرس بایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        SavePlace(
          this.currentPlace.id,
          this.currentBranch.id,
          this.currentPlace.name,
          this.currentPlace.address,
          this.currentPlace.active
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showDialog = false;
            this.GetBranchDeliveryPlace();
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        DeletePlace(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetBranchDeliveryPlace();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>